/**
 * View component for /certificate-templates/new
 *
 * Creates a new certificateTemplate from a copy of the defaultItem in the certificateTemplate reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as certificateTemplateActions from '../certificateTemplateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import certificateTemplate components
import CertificateTemplateForm from '../components/CertificateTemplateForm.js.jsx';

class AdminCreateCertificateTemplate extends Base {
  constructor(props) {
    super(props);
    this.state = {
      certificateTemplate: _.cloneDeep(this.props.defaultCertificateTemplate)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {
        bottomRight: 'useSponsor'
      }
      /**
       * NOTE: formHelpers are useful for things like radio controls and other
       * things that manipulate the form, but don't directly effect the state of
       * the certificateTemplate
       */
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    let newCertTemplate = {...this.state.certificateTemplate}
    if(this.state.certificateTemplate.bottomRightStatus !== 'overrideSponsor') {
      newCertTemplate.bottomRightLogoUrl = null
    }
    dispatch(certificateTemplateActions.sendCreateCertificateTemplate(newCertTemplate)).then(ctAction => {
      if(ctAction.success) {
        dispatch(certificateTemplateActions.invalidateList());
        history.push(`/admin/certificate-templates/${ctAction.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(res);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { certificateTemplate, formHelpers } = this.state;
    const isEmpty = (certificateTemplate.name === null || certificateTemplate.name === undefined);
    return (
      <div className="flex">
        <section className="section">
          {isEmpty ?
            <h2> Loading...</h2>
            :
            <CertificateTemplateForm
              certificateTemplate={certificateTemplate}
              cancelLink="/admin/certificate-templates"
              formHelpers={formHelpers}
              formTitle="Create Certificate Template"
              formType="create"
              handleFormChange={this._handleFormChange}
              handleFormSubmit={this._handleFormSubmit}
              />
          }
        </section>
      </div>
    )
  }
}

AdminCreateCertificateTemplate.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultCertificateTemplate: store.certificateTemplate.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateCertificateTemplate)
);



// WEBPACK FOOTER //
// modules/certificateTemplate/views/AdminCreateCertificateTemplate.js.jsx